<template>
    <modal @modal-close="handleClose">

        <div class="modal-wrapper">

            <CloseButton @click="handleClose" />

            <div class="modal-content">
                <div class="overflow-y-auto" style="max-height: 500px; -webkit-overflow-scrolling: touch;">
                    <DrawablePhoto
                        photoClass="mr-3 mb-3"
                        v-for="(photo, index) in photos"
                        :key="index"
                        :image="photo.image"
                        :drawing="photo.drawing"
                        :thumbnail="photo.thumbnail"
                        :width="photo.width"
                        :height="photo.height"
                        :loading="photo.loading"
                        :allow-drawing="true"
                        @change="updateDrawing(index, arguments[0])"
                        @delete="deletePhoto(index)"
                    />

                </div>
                <label>
                    <input
                        ref="fileField"
                        class="hidden"
                        type="file"
                        accept="image/*"
                        multiple
                        @change="handlePhotos"
                        :disabled="loading"
                    />
                    <span class="btn btn-default btn-secondary w-full medium:w-auto text-center mt-4"
                          :disabled="loading">
                        <Loader v-if="loading" />
                        <template v-else>
                            {{ $t('Add photo') }}
                        </template>
                    </span>
                </label>
            </div>

            <div class="modal-actions-outer-wrapper">
                <div class="modal-actions-inner-wrapper">
                    <button
                        type="button"
                        class="modal-actions-secondary"
                        @click.prevent="handleClose"
                    >
                        {{ $t('Cancel') }}
                    </button>

                    <button
                        type="button"
                        class="modal-actions-primary"
                        :disabled="loading"
                        @click.prevent="handleSave"
                    >
                        {{ $t('Save') }}
                    </button>
                </div>
            </div>

        </div>

    </modal>
</template>

<script>
    import PhotoReader from '@/util/PhotoReader';
    import DrawablePhoto from '@/components/DrawablePhoto/DrawablePhoto.vue';
    import CloseButton from '@/components/Modals/CloseButton.vue';
    import { eventBus } from '@/eventBus';
    import Loader from '@/components/Icons/Loader.vue';

    const photoStubDictionary = [];

    export default {
        name: 'ConductInspectionModalPhotos',
        components: {
            DrawablePhoto,
            CloseButton,
            Loader,
        },

        props: {
            item: {
                type: Object,
                required: true,
            },
        },

        data: () => ({
            photos: [],
            loadingPhotos: 0,
        }),

        created() {
            if (this.item.photos && this.item.photos.length > 0) {
                this.photos = JSON.parse(JSON.stringify(this.item.photos));
            }
        },

        mounted() {
            if (this.photos && this.photos.length > 0) return;
            this.$refs.fileField.click();
        },

        computed: {
            loading() {
                return this.loadingPhotos > 0;
            },
        },

        methods: {
            handleClose() {
                this.$emit('close');
            },

            handleSave() {
                this.$emit('save', this.photos);
            },

            deletePhoto(index) {
                this.photos.splice(index, 1);
            },

            updateDrawing(index, drawing) {
                this.photos[index].drawing = drawing;
            },

            async handlePhotos(event) {
                if (!event.target.files) return;

                // first iteration creates the loading placeholders
                for (let i = 0; i < event.target.files.length; i++) {
                    const file = event.target.files[i];
                    const photoStub = {
                        loading: true,
                        image: null,
                        width: null,
                        height: null,
                        drawing: null,
                        thumbnail: null,
                    };
                    this.photos.push(photoStub);
                    photoStubDictionary[i] = photoStub;
                    this.loadingPhotos += 1;
                }

                // second iteration loads and resizes the images, sequentially
                for (let i = 0; i < event.target.files.length; i++) {
                    const file = event.target.files[i];
                    const photoStub = photoStubDictionary[i];

                    if (photoStub) {
                        try {
                            // eslint-disable-next-line no-await-in-loop
                            const {
                                photo, thumbnail, width, height,
                            } = await PhotoReader.read(file);
                            photoStub.thumbnail = thumbnail;
                            photoStub.image = photo;
                            photoStub.width = width;
                            photoStub.height = height;
                            this.$delete(photoStub, 'loading');
                        } catch (error) {
                            const errorMessage = window.i18n.t('Error loading image: {message}', {
                                message: error.message,
                            });
                            eventBus.$emit('error', errorMessage);
                            const index = this.item.response.indexOf(photoStub);
                            if (index !== -1) this.item.response.splice(index, 1);
                        }
                        this.loadingPhotos -= 1;
                    }
                }
                event.target.value = null;
            },

        },
    };
</script>
